module.exports = __webpack_public_path__ + "static/img/join_pro.d797e75.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/join_pro.png
// module id = sM1a
// module chunks = 1